
export const FETCH_ALL_CREATERS_FOR_HOMEPAGE = 'FETCH_ALL_CREATERS_FOR_HOMEPAGE';
export const FETCH_ALL_CREATERS_SUCCESS_FOR_HOMEPAGE = 'FETCH_ALL_CREATERS_SUCCESS_FOR_HOMEPAGE';
export const FETCH_ALL_CREATERS_FAILURE_FOR_HOMEPAGE = 'FETCH_ALL_CREATERS_FAILURE_FOR_HOMEPAGE';



export const fetchAllCretaterforHomePage = () => ({
    type: FETCH_ALL_CREATERS_FOR_HOMEPAGE
  });